export default __webpack_public_path__ + "static/media/car-removebg-preview.1af0890b.png";